import { CheckmarkIcon } from '@american-autonomy/rantizo-ui';

import BaseNotification from 'components/BaseNotification';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SuccessNotification: FunctionComponent<Props> = ({ onClose, testId = TEST_ID, text }) => (
    <BaseNotification
        className={styles.successNotification}
        onClose={onClose}
        testId={testId}
        text={text}
    >
        <CheckmarkIcon className={styles.checkmarkIcon} />
    </BaseNotification>
);

export default SuccessNotification;
